const createContentTypeHeader = (type) => ({ "Content-Type": type });

export const MERGEPATCHJSON = createContentTypeHeader(
  "application/merge-patch+json"
);
export const LINKEDJSON = createContentTypeHeader("application/ld+json");
export const MULTIFORM = createContentTypeHeader("multipart/form-data");
